// Multilingual dictionary for Sarthi Associates
export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
];

// Speech synthesis locale mapping
export const SPEECH_LOCALE = { en: "en-IN", hi: "hi-IN", mr: "mr-IN", ta: "ta-IN" };

const dict = {
  brand: { en: "Sarthi Associates", hi: "सारथी एसोसिएट्स", mr: "सारथी असोसिएट्स", ta: "சாரதி அசோசியேட்ஸ்" },
  tagline: {
    en: "Trusted jobs for frontline workers",
    hi: "फ्रंटलाइन कामगारों के लिए भरोसेमंद काम",
    mr: "फ्रंटलाइन कामगारांसाठी विश्वासार्ह कामे",
    ta: "முன்நிலை தொழிலாளர்களுக்கான நம்பகமான வேலைகள்",
  },
  hero_headline: {
    en: "Find work. Get paid. Grow skills.",
    hi: "काम पाइए। पैसा कमाइए। हुनर बढ़ाइए।",
    mr: "काम मिळवा. पैसे कमवा. कौशल्य वाढवा.",
    ta: "வேலை பெறுங்கள். சம்பாதிக்கவும். திறமை வளர்க்கவும்.",
  },
  hero_sub: {
    en: "For welders, fitters, electricians, plumbers, riggers, technicians and helpers.",
    hi: "वेल्डर, फिटर, बिजली मिस्त्री, प्लंबर, रिगर, टेक्नीशियन और हेल्पर के लिए।",
    mr: "वेल्डर, फिटर, इलेक्ट्रिशियन, प्लंबर, रिगर, तंत्रज्ञ आणि मदतनीसांसाठी.",
    ta: "வெல்டர், பிட்டர், மின்சாரம், குழாய், ரிக்கர், தொழில்நுட்பர் மற்றும் உதவியாளர்களுக்காக.",
  },
  find_work: { en: "I want work", hi: "मुझे काम चाहिए", mr: "मला काम हवे", ta: "எனக்கு வேலை வேண்டும்" },
  post_work: { en: "I am a Business Partner", hi: "मैं बिज़नेस पार्टनर हूँ", mr: "मी बिझनेस पार्टनर आहे", ta: "நான் ஒரு வணிக பங்குதாரர்" },
  login: { en: "Login", hi: "लॉगिन", mr: "लॉगिन", ta: "உள்நுழை" },
  logout: { en: "Logout", hi: "लॉगआउट", mr: "लॉगआउट", ta: "வெளியேறு" },
  register: { en: "Register", hi: "पंजीकरण", mr: "नोंदणी", ta: "பதிவு" },
  worker: { en: "Worker", hi: "कामगार", mr: "कामगार", ta: "தொழிலாளி" },
  contractor: { en: "Business Partner", hi: "बिज़नेस पार्टनर", mr: "बिझनेस पार्टनर", ta: "வணிக பங்குதாரர்" },
  hr: { en: "HR / Recruiter", hi: "HR / भर्तीकर्ता", mr: "HR / भरती करणारा", ta: "HR / ஆட்சேர்ப்பாளர்" },
  premium_plans: { en: "Premium Plans", hi: "प्रीमियम प्लान", mr: "प्रीमियम प्लॅन", ta: "பிரீமியம் திட்டங்கள்" },
  consultancy: { en: "Engineering Consultancy", hi: "इंजीनियरिंग परामर्श", mr: "अभियांत्रिकी सल्ला", ta: "பொறியியல் ஆலோசனை" },
  book_consultant: { en: "Book Consultant", hi: "सलाहकार बुक करें", mr: "सल्लागार बुक करा", ta: "ஆலோசகர் புக் செய்க" },
  admin: { en: "Admin", hi: "प्रशासक", mr: "प्रशासक", ta: "நிர்வாகம்" },
  mobile_number: { en: "Mobile Number", hi: "मोबाइल नंबर", mr: "मोबाइल क्रमांक", ta: "மொபைல் எண்" },
  email: { en: "Email", hi: "ईमेल", mr: "ईमेल", ta: "மின்னஞ்சல்" },
  password: { en: "Password", hi: "पासवर्ड", mr: "पासवर्ड", ta: "கடவுச்சொல்" },
  send_otp: { en: "Send OTP", hi: "OTP भेजें", mr: "OTP पाठवा", ta: "OTP அனுப்பு" },
  enter_otp: { en: "Enter OTP", hi: "OTP दर्ज करें", mr: "OTP प्रविष्ट करा", ta: "OTP உள்ளிடுக" },
  verify: { en: "Verify", hi: "जाँच करें", mr: "पडताळणी", ta: "சரிபார்" },
  login_mobile: { en: "Login with Mobile", hi: "मोबाइल से लॉगिन", mr: "मोबाइलने लॉगिन", ta: "மொபைல் மூலம் உள்நுழை" },
  login_email: { en: "Login with Email", hi: "ईमेल से लॉगिन", mr: "ईमेलने लॉगिन", ta: "மின்னஞ்சல் மூலம்" },
  name: { en: "Full Name", hi: "पूरा नाम", mr: "पूर्ण नाव", ta: "முழு பெயர்" },
  select_skills: { en: "Tap your skills", hi: "अपने हुनर चुनें", mr: "तुमची कौशल्ये निवडा", ta: "உங்கள் திறமைகளைத் தேர்ந்தெடுக்கவும்" },
  experience: { en: "Experience (years)", hi: "अनुभव (साल)", mr: "अनुभव (वर्षे)", ta: "அனுபவம் (ஆண்டுகள்)" },
  location: { en: "Location / City", hi: "स्थान / शहर", mr: "स्थान / शहर", ta: "இடம் / நகரம்" },
  company: { en: "Company Name", hi: "कंपनी का नाम", mr: "कंपनीचे नाव", ta: "நிறுவனத்தின் பெயர்" },
  gst: { en: "GST Number (optional)", hi: "GST नंबर (वैकल्पिक)", mr: "GST क्रमांक (ऐच्छिक)", ta: "GST எண் (விருப்பம்)" },
  apply_now: { en: "Apply Now", hi: "अभी अप्लाई करें", mr: "आत्ता अर्ज करा", ta: "இப்போது விண்ணப்பிக்கவும்" },
  applied: { en: "Applied", hi: "अप्लाई हो गया", mr: "अर्ज केला", ta: "விண்ணப்பித்தது" },
  post_job: { en: "Post a Job", hi: "काम पोस्ट करें", mr: "काम पोस्ट करा", ta: "வேலை இடுக" },
  my_jobs: { en: "My Job Posts", hi: "मेरे काम", mr: "माझी कामे", ta: "என் வேலைகள்" },
  my_applications: { en: "My Applications", hi: "मेरे आवेदन", mr: "माझे अर्ज", ta: "என் விண்ணப்பங்கள்" },
  browse_jobs: { en: "Browse Jobs", hi: "काम खोजें", mr: "कामे शोधा", ta: "வேலைகள் காண்க" },
  categories: { en: "Categories", hi: "श्रेणियाँ", mr: "श्रेणी", ta: "பிரிவுகள்" },
  salary: { en: "Salary", hi: "वेतन", mr: "पगार", ta: "சம்பளம்" },
  positions: { en: "Positions", hi: "पद", mr: "पदे", ta: "பதவிகள்" },
  duration_days: { en: "Duration (days)", hi: "अवधि (दिन)", mr: "कालावधी (दिवस)", ta: "காலம் (நாட்கள்)" },
  read_aloud: { en: "Read aloud", hi: "पढ़कर सुनाएँ", mr: "मोठ्याने वाचा", ta: "சத்தமாக படிக்க" },
  voice_help: { en: "Voice Help", hi: "आवाज़ मदद", mr: "आवाज मदत", ta: "குரல் உதவி" },
  dashboard: { en: "Dashboard", hi: "डैशबोर्ड", mr: "डॅशबोर्ड", ta: "டாஷ்போர்டு" },
  applicants: { en: "Applicants", hi: "आवेदक", mr: "अर्जदार", ta: "விண்ணப்பதாரர்கள்" },
  new_here: { en: "New here?", hi: "यहाँ नए हैं?", mr: "इथे नवीन?", ta: "புதியவரா?" },
  already_have_account: { en: "Already have an account?", hi: "पहले से खाता है?", mr: "आधीच खाते आहे?", ta: "ஏற்கனவே கணக்கு உள்ளதா?" },
  create_account: { en: "Create Account", hi: "खाता बनाएँ", mr: "खाते तयार करा", ta: "கணக்கை உருவாக்கு" },
  title: { en: "Job Title", hi: "काम का नाम", mr: "कामाचे नाव", ta: "வேலை பெயர்" },
  description: { en: "Description", hi: "विवरण", mr: "वर्णन", ta: "விவரம்" },
  submit: { en: "Submit", hi: "जमा करें", mr: "सबमिट करा", ta: "சமர்ப்பி" },
  back: { en: "Back", hi: "वापस", mr: "मागे", ta: "பின்" },
  next: { en: "Next", hi: "आगे", mr: "पुढे", ta: "அடுத்து" },
  select_role: { en: "Who are you?", hi: "आप कौन हैं?", mr: "तुम्ही कोण आहात?", ta: "நீங்கள் யார்?" },
  demo_otp_hint: { en: "Demo OTP: 123456", hi: "डेमो OTP: 123456", mr: "डेमो OTP: 123456", ta: "டெமோ OTP: 123456" },
  all: { en: "All", hi: "सभी", mr: "सर्व", ta: "எல்லாம்" },
  no_jobs: { en: "No jobs found", hi: "कोई काम नहीं मिला", mr: "कामे सापडली नाहीत", ta: "வேலைகள் இல்லை" },
  contact_phone: { en: "Contact Phone", hi: "संपर्क फ़ोन", mr: "संपर्क फोन", ta: "தொலைபேசி" },
  status_open: { en: "Open", hi: "खुला", mr: "खुले", ta: "திறந்த" },
  status_closed: { en: "Closed", hi: "बंद", mr: "बंद", ta: "மூடியது" },
  close_job: { en: "Close Job", hi: "काम बंद करें", mr: "काम बंद करा", ta: "வேலையை மூடு" },
  applied_success: { en: "Applied successfully!", hi: "आवेदन सफल!", mr: "अर्ज यशस्वी!", ta: "விண்ணப்பம் வெற்றி!" },
  workers: { en: "Workers", hi: "कामगार", mr: "कामगार", ta: "தொழிலாளர்கள்" },
  jobs: { en: "Jobs", hi: "काम", mr: "कामे", ta: "வேலைகள்" },
  applications: { en: "Applications", hi: "आवेदन", mr: "अर्ज", ta: "விண்ணப்பங்கள்" },
  language: { en: "Language", hi: "भाषा", mr: "भाषा", ta: "மொழி" },
  about: { en: "About Us", hi: "हमारे बारे में", mr: "आमच्याबद्दल", ta: "எங்களைப் பற்றி" },
  nav_categories: { en: "Categories", hi: "श्रेणियाँ", mr: "श्रेणी", ta: "பிரிவுகள்" },
  our_leadership: { en: "Our Leadership", hi: "हमारा नेतृत्व", mr: "आमचे नेतृत्व", ta: "எங்கள் தலைமை" },
  our_vision: { en: "Our Vision", hi: "हमारा दृष्टिकोण", mr: "आमची दृष्टी", ta: "எங்கள் தொலைநோக்கு" },
  read_full_story: { en: "Read full story →", hi: "पूरी कहानी पढ़ें →", mr: "पूर्ण कथा वाचा →", ta: "முழு கதை →" },
  md_short_bio: {
    en: "B.Tech Electrical & Electronics · 14+ years in Thermal Power Plants and Alumina Refineries.",
    hi: "बी.टेक (इलेक्ट्रिकल एंड इलेक्ट्रॉनिक्स) · थर्मल पावर प्लांट व एल्युमिना रिफाइनरी में 14+ वर्षों का अनुभव।",
    mr: "बी.टेक (इलेक्ट्रिकल व इलेक्ट्रॉनिक्स) · थर्मल पावर प्लांट व अ‍ॅल्युमिना रिफायनरीमध्ये १४+ वर्षांचा अनुभव.",
    ta: "பி.டெக் மின் & மின்னணு · 14+ ஆண்டுகள் அனுபவம்.",
  },
  vision_short: {
    en: "To become India's most trusted digital bridge between frontline industrial workers and the projects that need them.",
    hi: "फ्रंटलाइन औद्योगिक कामगारों और उन्हें ज़रूरत वाले प्रोजेक्ट्स के बीच भारत का सबसे भरोसेमंद डिजिटल पुल बनना।",
    mr: "फ्रंटलाइन औद्योगिक कामगार आणि त्यांची गरज असणाऱ्या प्रकल्पांमधील भारतातील सर्वात विश्वासार्ह डिजिटल पूल बनणे.",
    ta: "இந்தியாவின் நம்பிக்கைமிக்க டிஜிட்டல் பாலம் ஆவது.",
  },
  categories_names: {
    welder: { en: "Welder", hi: "वेल्डर", mr: "वेल्डर", ta: "வெல்டர்" },
    fitter: { en: "Fitter", hi: "फिटर", mr: "फिटर", ta: "பிட்டர்" },
    electrician: { en: "Electrician", hi: "बिजली मिस्त्री", mr: "इलेक्ट्रिशियन", ta: "மின்சாரம்" },
    plumber: { en: "Plumber", hi: "प्लंबर", mr: "प्लंबर", ta: "குழாய்" },
    rigger: { en: "Rigger", hi: "रिगर", mr: "रिगर", ta: "ரிக்கர்" },
    technician: { en: "Technician", hi: "टेक्नीशियन", mr: "तंत्रज्ञ", ta: "தொழில்நுட்பர்" },
    helper: { en: "Helper", hi: "हेल्पर", mr: "मदतनीस", ta: "உதவியாளர்" },
    mason: { en: "Mason", hi: "राजमिस्त्री", mr: "गवंडी", ta: "கொத்தனார்" },
  },
};

export function t(key, lang = "en") {
  const path = key.split(".");
  let cur = dict;
  for (const p of path) {
    if (!cur || typeof cur !== "object") return key;
    cur = cur[p];
  }
  if (!cur) return key;
  if (typeof cur === "string") return cur;
  return cur[lang] || cur.en || key;
}
